import { Locale } from '@superbet-group/web.types';

// TODO unit tests
export function getPathLocale(
    path: string,
    targetLocales: Locale[],
    defaultLocale: Locale,
): Locale {
    if (!path) {
        return defaultLocale;
    }

    const parts = path
        .split('/')
        .filter(Boolean);

    if (parts.length === 0) {
        return defaultLocale;
    }

    const locale = toIsoFormatLocale(parts[0]);
    return targetLocales.includes(locale)
        ? locale
        : defaultLocale;
}

function toIsoFormatLocale(rawLocale: string): Locale {
    const parts = rawLocale.split('-');

    const last = parts.pop()!.toUpperCase();
    return [...parts, last].join('-') as unknown as Locale;
}

export const localeDisplayName: Record<Locale, string> = {
    [Locale.Romanian]: 'Romanian',
    [Locale.Polish]: 'Polish',
    [Locale.Serbian]: 'Serbian',
    [Locale.English]: 'English',
    [Locale.EnglishBrazilian]: 'English (Brazil)',
    [Locale.PortugueseBrazilian]: 'Português (Brasil)',
    [Locale.FrenchBelgian]: 'Français (Belgique)',
    [Locale.EnglishBelgian]: 'English (Belgium)',
    [Locale.DutchBelgian]: 'Nederlands (België)',
    [Locale.Bulgarian]: 'Bulgarian',
};
